import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocTeamAlertIssueSyncingCreateRoute: InvariantJiraRoute = {
	name: 'eoc-team-alert-issue-syncing-create',
	path: '/jira/ops/teams/:teamId/syncs/create',
	exact: true,
};
